// extracted by mini-css-extract-plugin
export default {"checker":"EzODsa","size-20":"l7W9gO","size-22":"WoUCd6","size-24":"zZLWqH","size-26":"bkZKO3","label":"xt_ZXU"};